import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';
import { UnimedAcolheButtonProps } from '../../../../interfaces/props/SaudeBemEstar/UnimedAcolhe/UnimedAcolheButtonProps';
import { sxFeatureCard } from '../sxProps';
import './styles.css';

function UnimedAcolheButton(props: UnimedAcolheButtonProps) {

    const accessibility = useAccessibility();

    return (
        <>
            <Button sx={sxFeatureCard} onClick={props.handleClick} style={{ ...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
                <div style={accessibility.contrastColorAccessibility} className='feature-card-icon' dangerouslySetInnerHTML={{ __html: props.icon }} />
                <span className='unimed-acolhe-button-name' style={accessibility.textStyleAccessibility}>{props.name}</span>
            </Button>
        </>
    );
}

export default UnimedAcolheButton;